/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: c798baf7863e
 */

import * as z from "zod";

/**
 * Represents an upload mapping
 */
export type UploadMapping = {
  folder: string;
  template: string;
  external_id: string;
  upload_preset_name?: string | null | undefined;
};

export const UploadMapping$zodSchema: z.ZodType<UploadMapping> = z.object({
  external_id: z.string().describe("Unique identifier for the mapping"),
  folder: z.string().describe("The folder name"),
  template: z.string().describe("The template URL"),
  upload_preset_name: z.string().nullable().optional().describe(
    "Name of an upload preset if one is associated",
  ),
}).describe("Represents an upload mapping");
